import React, { useEffect } from 'react';
import Chart from 'react-apexcharts';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';

import { dominioDemandaCirurgica } from '../../../config/database';

export default function DemandaConvertidaPedido(props) {
  const [options, setOptions] = React.useState({
    series: [],
    labels: [],
    dataLabels: {
      enabled: false,
    },
    legend: {
      show: false,
    },
  });
  const { equipes, centrosCirurgicos, dataInicio, dataFim, eOnco } = props;

  const updateCharts = () => {
    const idsEquipes = equipes.map(equipe => {
      return equipe.id;
    });

    const idsCentrosCirurgicos = centrosCirurgicos.map(centroCirurgico => {
      return centroCirurgico.id;
    });

    const dados = {
      filtros: {
        equipes: idsEquipes?.length > 0 ? idsEquipes.join() : null,
        centrosCirurgicos: idsCentrosCirurgicos?.length > 0 ? idsCentrosCirurgicos.join() : null,
        dataInicio: new Date(dataInicio),
        dataFim: new Date(dataFim),
        eOnco,
      },
    };

    dominioDemandaCirurgica.post(`/api/listarDemandaConvertidaPedido`, dados).then(response => {
      const config = {
        series: [],
        labels: ['DEMANDA', 'PEDIDO'],
        dataLabels: {
          enabled: false,
        },
        legend: {},
      };
      const demandas = response.data.map(dado => {
        return dado.demanda_aberto;
      });
      const pedidos = response.data.map(dado => {
        return dado.demanda_finalizada;
      });
      const series = [demandas[0], pedidos[0]];
      config.series = series;
      // config.labels = labels;
      setOptions(config);
    });
  };

  useEffect(() => {
    updateCharts();
  }, [equipes, centrosCirurgicos, dataInicio, dataFim, eOnco]);

  return (
    <Card style={{ height: 150, width: '100%' }}>
      <CardHeader
        align="center"
        title="Demanda convertida em pedido"
        style={{
          backgroundColor: '#32428C',
          color: 'white',
          height: 45,
          fontSize: 14,
          fontWeight: 'bold',
        }}
        size="1"
        disableTypography
      />
      <CardContent>
        <Chart options={options} series={options.series} type="pie" height={100} />
      </CardContent>
    </Card>
  );
}
